import { Customizations } from 'models'

const searchResultTableLabels: Customizations = {
  no: {
    label: 'Réf',
    isDisplayed: true,
  },
  referenceVendeur: {
    label: 'Réf. vendeur',
    isDisplayed: true,
  },
  licensePlate: {
    label: 'Immatriculation',
    isDisplayed: true,
  },
  make: {
    label: 'Marque',
    isDisplayed: true,
  },
  bodyType: {
    label: 'Type com',
    isDisplayed: true,
  },
  receiptDate: {
    label: 'Date de livraison',
    isDisplayed: true,
  },
  auctionStartDateTime: {
    label: 'Date de vente',
    isDisplayed: true,
  },
  administrativeStatus: {
    label: 'Statut général',
    isDisplayed: true,
  },
  auctionStatus: {
    label: 'Sous-Statut',
    isDisplayed: true,
  },
  estimationApporteur: {
    label: 'Estimation',
    isDisplayed: true,
  },
  coteArgusKm: {
    label: 'coteArgusKm',
    isDisplayed: true,
  },
  coteArgusPriceDate: {
    label: 'coteArgusPriceDate',
    isDisplayed: true,
  },
}

export { searchResultTableLabels }
